// Also Required Shopify's money_format_without_zero
class PIPriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    // this.maxInput = this.querySelector("[data-input-max]");

    // this.minInput = this.querySelector("[data-input-min]");

    this.maxInput = this.closest(
      ".pi-mobile-facets__submenu--price"
    ).querySelector('[name="filter.v.price.lte"]');

    this.minInput = this.closest(
      ".pi-mobile-facets__submenu--price"
    ).querySelector('[name="filter.v.price.gte"]');

    this.options = {
      min: parseInt(this.dataset.min) || 0,

      max: parseInt(this.dataset.max),

      from: parseInt(this.dataset.from) || 0,

      to: parseInt(this.dataset.to) || parseInt(this.dataset.max),

      step: 100,

      min_interval: 0,

      max_interval: 0,

      force_edges: false,
    };

    this.rs = this.querySelector("[data-range-slider]");

    this.bar = this.querySelector("[data-slider-bar]");

    this.s_from = this.querySelector('[data-handle="from"]');

    this.s_to = this.querySelector('[data-handle="to"]');

    this.line = this.querySelector("[data-slider-line]");

    //   Lables

    this.l_min = this.querySelector("[data-label-min]");

    this.l_max = this.querySelector("[data-label-max]");

    this.l_from = this.querySelector("[data-label-from]");

    this.l_to = this.querySelector("[data-label-to]");

    this.l_single = this.querySelector("[data-label-single]");

    this.is_active = false;

    this.dragging = false;

    this.calc_count = 0;

    this.no_diapason = false;

    this.force_redraw = false;

    this.coords = {
      // left

      x_gap: 0,

      x_pointer: 0,

      // width

      w_rs: 0,

      w_rs_old: 0,

      w_handle: 0,

      // percents

      p_gap: 0,

      p_gap_left: 0,

      p_gap_right: 0,

      p_step: 0,

      p_pointer: 0,

      p_handle: 0,

      p_single_fake: 0,

      p_single_real: 0,

      p_from_fake: 0,

      p_from_real: 0,

      p_to_fake: 0,

      p_to_real: 0,

      p_bar_x: 0,

      p_bar_w: 0,

      //   // grid

      //   grid_gap: 0,

      //   big_num: 0,

      //   big: [],

      //   big_w: [],

      //   big_p: [],

      //   big_x: [],
    };

    this.labels = {
      // width

      w_min: 0,

      w_max: 0,

      w_from: 0,

      w_to: 0,

      w_single: 0,

      // percents

      p_min: 0,

      p_max: 0,

      p_from_fake: 0,

      p_from_left: 0,

      p_to_fake: 0,

      p_to_left: 0,

      p_single_fake: 0,

      p_single_left: 0,
    };

    this.result = {
      min: this.options.min,

      max: this.options.max,

      from: this.options.from,

      from_percent: 0,

      from_value: null,

      to: this.options.to,

      to_percent: 0,

      to_value: null,
    };
  }

  connectedCallback() {
    this.coords.p_step = this.convertToPercent(this.options.step, true);

    if (this.no_diapason) return;

    document.addEventListener("mousemove", this.pointerMove.bind(this));

    document.addEventListener("touchmove", this.pointerMove.bind(this));

    document.addEventListener("mouseup", this.pointerUp.bind(this));

    document.addEventListener("touchend", this.pointerUp.bind(this));

    this.s_from.addEventListener(
      "mousedown",

      this.pointerDown.bind(this, "from")
    );

    this.s_to.addEventListener("mousedown", this.pointerDown.bind(this, "to"));

    this.s_from.addEventListener(
      "touchstart",

      this.pointerDown.bind(this, "from")
    );

    this.s_to.addEventListener("touchstart", this.pointerDown.bind(this, "to"));

    this.line.addEventListener(
      "mousedown",

      this.pointerClick.bind(this, "click")
    );

    this.line.addEventListener(
      "touchstart",

      this.pointerClick.bind(this, "click")
    );

    this.bar.addEventListener(
      "mousedown",

      this.pointerClick.bind(this, "click")
    );

    this.bar.addEventListener(
      "touchstart",

      this.pointerClick.bind(this, "click")
    );

    this.target = "base";

    this.setMinMax();

    this.force_redraw = true;

    this.calc(true);

    this.updateScene();
  }

  /**

   * Mousedown or touchstart

   * for other slider elements, like diapason line

   *

   * @param target {String}

   * @param e {Object} event object

   */

  pointerClick(target, e) {
    e.preventDefault();

    const x = e.pageX || e.touches[0].pageX;

    if (e.button === 2) {
      return;
    }

    this.target = target;

    this.is_click = true;

    this.coords.x_gap = this.offset(this.rs).left;

    this.coords.x_pointer = +(x - this.coords.x_gap).toFixed();

    this.force_redraw = true;

    this.calc();
  }

  pointerDown(target, e) {
    // e.preventDefault();

    const x = e.pageX || e.touches[0].pageX;

    if (!target) {
      target = this.target || "from";
    }

    this.dragging = true;

    this.is_active = true;

    this.target = target;

    this.coords.x_gap = this.offset(this.rs).left;

    this.coords.x_pointer = x - this.coords.x_gap;

    this.calcPointerPercent();

    this.changeLevel(target);

    this.updateScene();
  }

  pointerUp(event) {
    // event.preventDefault();

    if (this.is_active) {
      this.is_active = false;
    } else {
      return;
    }

    this.querySelector(".state_hover").classList.remove("state_hover");

    this.force_redraw = true;

    this.updateScene();

    this.dragging = false;
  }

  changeLevel(target) {
    if (target === "from") {
      this.s_from.classList.add("state_hover");

      this.s_from.classList.add("type_last");

      this.s_to.classList.remove("state_hover");
    } else if (target === "to") {
      this.s_to.classList.add("state_hover");

      this.s_to.classList.add("type_last");

      this.s_from.classList.remove("state_hover");
    }
  }

  pointerMove(event) {
    //  event.preventDefault();

    if (!this.dragging) {
      return;
    }

    const x = event.pageX || event.touches[0].pageX;

    this.coords.x_pointer = x - this.coords.x_gap;

    this.calc();
  }

  /**

   * All calculations and measures start here

   *

   * @param update {boolean=}

   */

  calc(update) {
    this.calc_count++;

    if (this.calc_count === 10 || update) {
      this.calc_count = 0;

      this.coords.w_rs = this.rs.offsetWidth;

      this.calcHandlePercent();
    }

    if (!this.coords.w_rs) {
      return;
    }

    this.calcPointerPercent();

    var handle_x = this.getHandleX();

    if (this.target === "click") {
      this.coords.p_gap = this.coords.p_handle / 2;

      handle_x = this.getHandleX();

      this.target = this.chooseHandle(handle_x);
    }

    // console.log("DE+========");

    // console.log(handle_x);

    // console.log(this.target);

    // console.log(this.coords);

    switch (this.target) {
      case "base":
        var w = (this.options.max - this.options.min) / 100,
          f = (this.result.from - this.options.min) / w,
          t = (this.result.to - this.options.min) / w;

        this.coords.p_single_real = this.toFixed(f);

        this.coords.p_from_real = this.toFixed(f);

        this.coords.p_to_real = this.toFixed(t);

        this.coords.p_single_real = this.checkDiapason(
          this.coords.p_single_real,

          this.options.from_min,

          this.options.from_max
        );

        this.coords.p_from_real = this.checkDiapason(
          this.coords.p_from_real,

          this.options.from_min,

          this.options.from_max
        );

        this.coords.p_to_real = this.checkDiapason(
          this.coords.p_to_real,

          this.options.to_min,

          this.options.to_max
        );

        this.coords.p_single_fake = this.convertToFakePercent(
          this.coords.p_single_real
        );

        this.coords.p_from_fake = this.convertToFakePercent(
          this.coords.p_from_real
        );

        this.coords.p_to_fake = this.convertToFakePercent(
          this.coords.p_to_real
        );

        this.target = null;

        break;

      case "from":
        this.coords.p_from_real = this.convertToRealPercent(handle_x);

        this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);

        if (this.coords.p_from_real > this.coords.p_to_real) {
          this.coords.p_from_real = this.coords.p_to_real;
        }

        this.coords.p_from_real = this.checkDiapason(
          this.coords.p_from_real,

          this.options.from_min,

          this.options.from_max
        );

        this.coords.p_from_real = this.checkMinInterval(
          this.coords.p_from_real,

          this.coords.p_to_real,

          "from"
        );

        this.coords.p_from_real = this.checkMaxInterval(
          this.coords.p_from_real,

          this.coords.p_to_real,

          "from"
        );

        this.coords.p_from_fake = this.convertToFakePercent(
          this.coords.p_from_real
        );

        break;

      case "to":
        this.coords.p_to_real = this.convertToRealPercent(handle_x);

        this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);

        if (this.coords.p_to_real < this.coords.p_from_real) {
          this.coords.p_to_real = this.coords.p_from_real;
        }

        this.coords.p_to_real = this.checkDiapason(
          this.coords.p_to_real,

          this.options.to_min,

          this.options.to_max
        );

        this.coords.p_to_real = this.checkMinInterval(
          this.coords.p_to_real,

          this.coords.p_from_real,

          "to"
        );

        this.coords.p_to_real = this.checkMaxInterval(
          this.coords.p_to_real,

          this.coords.p_from_real,

          "to"
        );

        this.coords.p_to_fake = this.convertToFakePercent(
          this.coords.p_to_real
        );

        break;

      case "both_one":
        var real_x = this.convertToRealPercent(handle_x),
          from = this.result.from_percent,
          to = this.result.to_percent,
          full = to - from,
          half = full / 2,
          new_from = real_x - half,
          new_to = real_x + half;

        if (new_from < 0) {
          new_from = 0;

          new_to = new_from + full;
        }

        if (new_to > 100) {
          new_to = 100;

          new_from = new_to - full;
        }

        this.coords.p_from_real = this.calcWithStep(new_from);

        this.coords.p_from_real = this.checkDiapason(
          this.coords.p_from_real,

          this.options.from_min,

          this.options.from_max
        );

        this.coords.p_from_fake = this.convertToFakePercent(
          this.coords.p_from_real
        );

        this.coords.p_to_real = this.calcWithStep(new_to);

        this.coords.p_to_real = this.checkDiapason(
          this.coords.p_to_real,

          this.options.to_min,

          this.options.to_max
        );

        this.coords.p_to_fake = this.convertToFakePercent(
          this.coords.p_to_real
        );

        break;
    }

    this.coords.p_bar_x = this.toFixed(
      this.coords.p_from_fake + this.coords.p_handle / 2
    );

    this.coords.p_bar_w = this.toFixed(
      this.coords.p_to_fake - this.coords.p_from_fake
    );

    this.result.from_percent = this.coords.p_from_real;

    this.result.from = this.convertToValue(this.coords.p_from_real);

    this.result.to_percent = this.coords.p_to_real;

    this.result.to = this.convertToValue(this.coords.p_to_real);

    this.calcMinMax();

    this.calcLabels();
  }

  offset(el) {
    return el.getBoundingClientRect();
  }

  toFixed(num) {
    num = num.toFixed(20);

    return +num;
  }

  /**

   * calculates pointer X in percent

   */

  calcPointerPercent() {
    if (!this.coords.w_rs) {
      this.coords.p_pointer = 0;

      return;
    }

    if (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)) {
      this.coords.x_pointer = 0;
    } else if (this.coords.x_pointer > this.coords.w_rs) {
      this.coords.x_pointer = this.coords.w_rs;
    }

    this.coords.p_pointer = this.toFixed(
      (this.coords.x_pointer / this.coords.w_rs) * 100
    );
  }

  convertToRealPercent(fake) {
    var full = 100 - this.coords.p_handle;

    return (fake / full) * 100;
  }

  convertToFakePercent(real) {
    var full = 100 - this.coords.p_handle;

    return (real / 100) * full;
  }

  getHandleX() {
    var max = 100 - this.coords.p_handle,
      x = this.toFixed(this.coords.p_pointer - this.coords.p_gap);

    if (x < 0) {
      x = 0;
    } else if (x > max) {
      x = max;
    }

    return x;
  }

  calcHandlePercent() {
    this.coords.w_handle = this.s_from.offsetWidth;

    this.coords.p_handle = this.toFixed(
      (this.coords.w_handle / this.coords.w_rs) * 100
    );
  }

  /**

   * Find closest handle to pointer click

   *

   * @param real_x {Number}

   * @returns {String}

   */

  chooseHandle(real_x) {
    var m_point =
      this.coords.p_from_real +
      (this.coords.p_to_real - this.coords.p_from_real) / 2;

    if (real_x >= m_point) {
      return this.options.to_fixed ? "from" : "to";
    } else {
      return this.options.from_fixed ? "to" : "from";
    }
  }

  /**

   * Round percent value with step

   *

   * @param percent {Number}

   * @returns percent {Number} rounded

   */

  calcWithStep(percent) {
    var rounded = Math.round(percent / this.coords.p_step) * this.coords.p_step;

    if (rounded > 100) {
      rounded = 100;
    }

    if (percent === 100) {
      rounded = 100;
    }

    return this.toFixed(rounded);
  }

  checkMinInterval(p_current, p_next, type) {
    var o = this.options,
      current,
      next;

    if (!o.min_interval) {
      return p_current;
    }

    current = this.convertToValue(p_current);

    next = this.convertToValue(p_next);

    if (type === "from") {
      if (next - current < o.min_interval) {
        current = next - o.min_interval;
      }
    } else {
      if (current - next < o.min_interval) {
        current = next + o.min_interval;
      }
    }

    return this.convertToPercent(current);
  }

  checkMaxInterval(p_current, p_next, type) {
    var o = this.options,
      current,
      next;

    if (!o.max_interval) {
      return p_current;
    }

    current = this.convertToValue(p_current);

    next = this.convertToValue(p_next);

    if (type === "from") {
      if (next - current > o.max_interval) {
        current = next - o.max_interval;
      }
    } else {
      if (current - next > o.max_interval) {
        current = next + o.max_interval;
      }
    }

    return this.convertToPercent(current);
  }

  /**

   * Convert real value to percent

   *

   * @param value {Number} X in real

   * @param no_min {boolean=} don't use min value

   * @returns {Number} X in percent

   */

  convertToPercent(value, no_min) {
    var diapason = this.options.max - this.options.min,
      one_percent = diapason / 100,
      val,
      percent;

    if (!diapason) {
      this.no_diapason = true;

      return 0;
    }

    if (no_min) {
      val = value;
    } else {
      val = value - this.options.min;
    }

    percent = val / one_percent;

    return this.toFixed(percent);
  }

  checkDiapason(p_num, min, max) {
    var num = this.convertToValue(p_num),
      o = this.options;

    if (typeof min !== "number") {
      min = o.min;
    }

    if (typeof max !== "number") {
      max = o.max;
    }

    if (num < min) {
      num = min;
    }

    if (num > max) {
      num = max;
    }

    return this.convertToPercent(num);
  }

  /**

   * Convert percent to real values

   *

   * @param percent {Number} X in percent

   * @returns {Number} X in real

   */

  convertToValue(percent) {
    var min = this.options.min,
      max = this.options.max,
      min_decimals = min.toString().split(".")[1],
      max_decimals = max.toString().split(".")[1],
      min_length,
      max_length,
      avg_decimals = 0,
      abs = 0;

    if (percent === 0) {
      return this.options.min;
    }

    if (percent === 100) {
      return this.options.max;
    }

    if (min_decimals) {
      min_length = min_decimals.length;

      avg_decimals = min_length;
    }

    if (max_decimals) {
      max_length = max_decimals.length;

      avg_decimals = max_length;
    }

    if (min_length && max_length) {
      avg_decimals = min_length >= max_length ? min_length : max_length;
    }

    if (min < 0) {
      abs = Math.abs(min);

      min = +(min + abs).toFixed(avg_decimals);

      max = +(max + abs).toFixed(avg_decimals);
    }

    var number = ((max - min) / 100) * percent + min,
      string = this.options.step.toString().split(".")[1],
      result;

    if (string) {
      number = +number.toFixed(string.length);
    } else {
      number = number / this.options.step;

      number = number * this.options.step;

      number = +number.toFixed(0);
    }

    if (abs) {
      number -= abs;
    }

    if (string) {
      result = +number.toFixed(string.length);
    } else {
      result = this.toFixed(number);
    }

    if (result < this.options.min) {
      result = this.options.min;
    } else if (result > this.options.max) {
      result = this.options.max;
    }

    return result;
  }

  /**

   * Measure Min and Max labels width in percent

   */

  calcMinMax() {
    if (!this.coords.w_rs) {
      return;
    }

    this.labels.p_min = (this.labels.w_min / this.coords.w_rs) * 100;

    this.labels.p_max = (this.labels.w_max / this.coords.w_rs) * 100;
  }

  checkEdges(left, width) {
    if (!this.options.force_edges) {
      return this.toFixed(left);
    }

    if (left < 0) {
      left = 0;
    } else if (left > 100 - width) {
      left = 100 - width;
    }

    return this.toFixed(left);
  }

  /**

   * Measure labels width and X in percent

   */

  calcLabels() {
    if (!this.coords.w_rs) {
      return;
    }

    this.labels.w_from = this.l_from.offsetWidth;

    this.labels.p_from_fake = (this.labels.w_from / this.coords.w_rs) * 100;

    this.labels.p_from_left =
      this.coords.p_from_fake +
      this.coords.p_handle / 2 -
      this.labels.p_from_fake / 2;

    this.labels.p_from_left = this.toFixed(this.labels.p_from_left);

    this.labels.p_from_left = this.checkEdges(
      this.labels.p_from_left,

      this.labels.p_from_fake
    );

    this.labels.w_to = this.l_to.offsetWidth;

    this.labels.p_to_fake = (this.labels.w_to / this.coords.w_rs) * 100;

    this.labels.p_to_left =
      this.coords.p_to_fake +
      this.coords.p_handle / 2 -
      this.labels.p_to_fake / 2;

    this.labels.p_to_left = this.toFixed(this.labels.p_to_left);

    this.labels.p_to_left = this.checkEdges(
      this.labels.p_to_left,

      this.labels.p_to_fake
    );

    this.labels.w_single = this.l_single.offsetWidth;

    this.labels.p_single_fake = (this.labels.w_single / this.coords.w_rs) * 100;

    this.labels.p_single_left =
      (this.labels.p_from_left +
        this.labels.p_to_left +
        this.labels.p_to_fake) /
        2 -
      this.labels.p_single_fake / 2;

    this.labels.p_single_left = this.toFixed(this.labels.p_single_left);

    this.labels.p_single_left = this.checkEdges(
      this.labels.p_single_left,

      this.labels.p_single_fake
    );
  }

  /*=====================

    Drawings

  ========================*/

  updateScene() {
    if (this.raf_id) {
      cancelAnimationFrame(this.raf_id);

      this.raf_id = null;
    }

    clearTimeout(this.update_tm);

    this.update_tm = null;

    if (!this.options) {
      return;
    }

    this.drawHandles();

    if (this.is_active) {
      this.raf_id = requestAnimationFrame(this.updateScene.bind(this));
    } else {
      this.update_tm = setTimeout(this.updateScene.bind(this), 300);
    }
  }

  drawHandles() {
    this.coords.w_rs = this.rs.offsetWidth;

    if (!this.coords.w_rs) {
      return;
    }

    if (this.coords.w_rs !== this.coords.w_rs_old) {
      this.target = "base";

      this.is_resize = true;
    }

    if (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) {
      this.setMinMax();

      this.calc(true);

      this.drawLabels();

      this.force_redraw = true;

      this.coords.w_rs_old = this.coords.w_rs;
    }

    if (!this.coords.w_rs) {
      return;
    }

    if (!this.dragging && !this.force_redraw && !this.is_key) {
      return;
    }

    if (
      this.old_from !== this.result.from ||
      this.old_to !== this.result.to ||
      this.force_redraw ||
      this.is_key
    ) {
      this.drawLabels();

      this.bar.style.left = this.coords.p_bar_x + "%";

      this.bar.style.width = this.coords.p_bar_w + "%";

      this.s_from.style.left = this.coords.p_from_fake + "%";

      this.s_to.style.left = this.coords.p_to_fake + "%";

      if (this.old_from !== this.result.from || this.force_redraw) {
        this.l_from.style.left = this.labels.p_from_left + "%";
      }

      if (this.old_to !== this.result.to || this.force_redraw) {
        this.l_to.style.left = this.labels.p_to_left + "%";
      }

      this.l_single.style.left = this.labels.p_single_left + "%";

      this.old_from = this.result.from;

      this.old_to = this.result.to;

      if (this.is_key || this.is_click) {
        this.is_key = false;

        this.is_click = false;
      }

      this.is_update = false;

      this.is_resize = false;

      this.is_finish = false;

      //   console.log(this.coords);

      //   console.log(this.labels);

      //   console.log(this.result);
    }

    this.is_start = false;

    this.is_key = false;

    this.is_click = false;

    this.force_redraw = false;

    this.writeInputs();
  }

  /**

   * Draw labels

   * measure labels collisions

   * collapse close labels

   */

  drawLabels() {
    var text_single;

    text_single = this.formatePrice(this.result.from);

    text_single += " - ";

    text_single += this.formatePrice(this.result.to);

    this.l_single.innerHTML = text_single;

    this.l_from.innerHTML = this.formatePrice(this.result.from);

    this.l_to.innerHTML = this.formatePrice(this.result.to);

    this.calcLabels();

    var min = Math.min(this.labels.p_single_left, this.labels.p_from_left),
      single_left = this.labels.p_single_left + this.labels.p_single_fake,
      to_left = this.labels.p_to_left + this.labels.p_to_fake,
      max = Math.max(single_left, to_left);

    if (
      this.labels.p_from_left + this.labels.p_from_fake >=
      this.labels.p_to_left
    ) {
      this.l_from.style.visibility = "hidden";

      this.l_to.style.visibility = "hidden";

      this.l_single.style.visibility = "visible";

      if (this.result.from === this.result.to) {
        if (this.target === "from") {
          this.l_from.style.visibility = "visible";
        } else if (this.target === "to") {
          this.l_to.style.visibility = "visible";
        } else if (!this.target) {
          this.l_from.style.visibility = "visible";
        }

        this.l_single.style.visibility = "hidden";

        max = to_left;
      } else {
        this.l_from.style.visibility = "hidden";

        this.l_to.style.visibility = "hidden";

        this.l_single.style.visibility = "visible";

        max = Math.max(single_left, to_left);
      }
    } else {
      this.l_from.style.visibility = "visible";

      this.l_to.style.visibility = "visible";

      this.l_single.style.visibility = "hidden";
    }

    if (min < this.labels.p_min + 1) {
      this.l_min.style.visibility = "hidden";
    } else {
      this.l_min.style.visibility = "visible";
    }

    if (max > 100 - this.labels.p_max - 1) {
      this.l_max.style.visibility = "hidden";
    } else {
      this.l_max.style.visibility = "visible";
    }
  }

  /**

   * Set visibility and content

   * of Min and Max labels

   */

  setMinMax() {
    if (!this.options) {
      return;
    }

    this.l_min.innerHTML = this.formatePrice(this.options.min);

    this.l_max.innerHTML = this.formatePrice(this.options.max);

    this.labels.w_min = this.l_min.offsetWidth;

    this.labels.w_max = this.l_max.offsetWidth;
  }

  formatePrice(price) {
    // console.log(price);
    return Shopify.formatMoney(price, Shopify.money_format);
  }

  writeInputs() {
    if (this.minInput) {
      this.minInput.value = this.result.from / 100;

      if (this.result.from <= 0) {
        this.minInput.value = "";
      }
    }

    if (this.maxInput) {
      this.maxInput.value = this.result.to / 100;

      if (this.result.to == this.options.max) {
        this.maxInput.value = "";
      }
    }
  }
}

customElements.define("pi-price-range-slider", PIPriceRangeSlider);
